import Header from './Header';
import VehicleSelection from './VehicleSelection';
import ChatWindow from './ChatWindow';
import './App.css';
import { useState } from 'react';
import { AUTOMOTIVE_SITE } from './shared/constants';
import Review from './Review';

function App() {
  const [startChat, setStartChat] = useState(!AUTOMOTIVE_SITE.IS_AUTO);
  
  const handleProceed = (e: React.MouseEvent<HTMLButtonElement>) => {
    setStartChat(true);
    e.preventDefault();
  };

  return (
    <div className="app">
      <Header handleProceed={handleProceed} />
      {startChat ? (
        <>
          <VehicleSelection />
          <ChatWindow />
          {!AUTOMOTIVE_SITE.IS_AUTO ? <Review title="Diagnostic AI Review" /> : null}
        </>
      ) : null}
    </div>
  );
}

export default App;
